<template>
    <div>
        <card-header title="Application Details" icon="fa-file-certificate"></card-header>
        <card-body>

            <application-view :application="application" :applicant="applicant" v-if="loaded"></application-view>

<!--                        <json-viewer :value="application"></json-viewer>-->
<!--                        <json-viewer :value="applicant"></json-viewer>-->
<!--                        <json-viewer :value="applicant.reg_application_data"></json-viewer>-->
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http, apiUrl} from "@/http_client";

    import CardToolbar from "../../../TIER/components/CardToolbar.vue";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";

    import async from "async";
    import DataRow from "../../../TIER/components/DataRow.vue";
    import RenderEditorJsApplication from "./EditorJs/Render.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";
    import moment from "moment/moment";
    import {mapGetters} from "vuex";
    import ApplicationView from "./ApplicationView.vue";


    export default {
        props: ['card', 'child', 'props'],
        components: {ApplicationView, CardListItem, RenderEditorJsApplication, DataRow, ApplicantTile, CardToolbar, CardFooter, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                loaded: false,
                application: {
                    cert: {},
                    organization: {}
                },
                applicant: {
                    users: {},
                    reg_application_data: []
                },
                apiUrl: apiUrl,
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
            lastStepCount() {
                return this.application.outline.length + ((this.applicant.quoted_price) ? 2 : 1);
            }
        },
        methods: {

            loadApplicant: function (force) {
                this.$emit('loading', true);
                async.parallel([
                    // get applicant
                    (cb) => {
                        http.get('/applicants/' + this.props.applicantType + '/' + this.props.applicantId, {force}).then(response => {
                            this.applicant = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    // get application
                    (cb) => {
                        http.get('applications/' + this.props.applicationId, {force}).then(response => {
                            if (!response.data.outline) response.data.outline = [];
                            this.application = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                    this.loaded = true;
                });
            },
            getOutlineContent(outline) {
                return JSON.parse(outline.component.content);
            },
            getAppData(id) {
                if (this.applicant.enrollment_id) {
                    return (this.applicant.enrollment_application_data.find(d => d.field === id)) ? this.applicant.enrollment_application_data.find(d => d.field === id).value : '';
                } else if (this.applicant.registration_id) {
                    return (this.applicant.reg_application_data.find(d => d.field === id)) ? this.applicant.reg_application_data.find(d => d.field === id).value : '';

                }
            },
            getSignature(id) {
                //todo, the way the data is saved isn't the best, but this should work for now.  Typically 'field' would be the id
                return this.applicant.reg_application_data.find(d => d.field === 'signature' && d.block.id === id).value.signature;
            },
            getHistoryCount(id) {
                // todo, this isn't in use but it does show the total number of entries for a given field
                return (this.applicant.reg_application_data.filter(d => d.field === id)).length;
            },
            getTotalSessions() {
                let titles = [];
                this.applicant.log_snapshot.forEach(entry => {
                    if (!titles.includes(entry.title)) titles.push(entry.title);
                });
                return titles.length;
            },
            displayDates: function(start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('dddd, MMMM Do, h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, h:mm A') + ' - ' + e.format('MMM Do, h:mm A');
                }
            },
            reload: function () {
                this.loadApplicant(true);
            }
        },
        watch: {
            'props.applicantId': function () {
                this.type = this.props.type;
                this.loadApplicant(true);
            }
        },
        mounted: function () {
            this.loadApplicant();
        }
    };
</script>

<style lang="scss" scoped>
    .meta {
        font-size: 0.85rem !important;
        line-height: normal !important;
    }
    .tile-title {
        font-size: 0.85rem;
        font-weight: bold;
    }

    .signature {
        border: 1px solid #ddd;
    }
</style>


